import moment from 'moment';

export function getToday(isUTC?: boolean): moment.Moment {
    return isUTC ? moment.utc() : moment();
}
